import AxiosFoundationAPI from "../../../../util/AxiosFoundationAPI";
import {V1MembershipCapabilityIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import {SessionContext} from "../../../../util/SessionContext";
import {v4 as uuidv4} from "uuid";

// The active persona (visibility) headers must ride on grant/revoke so the server-side steward guard
// (enforce_object_share_management) can tell whether the caller administers the target group. Without these,
// enforcement rejects everyone — including the administrator.
function visibilityHeaders() {
    const visibility = new SessionContext().getActiveVisibility() || {};
    return {
        "visibility-mode": visibility.Mode ?? "",
        "visibility-value": visibility.Value ?? "",
    };
}

// The capabilities granted to one *_MEMBERSHIP share (per-share grants). Queried by MembershipUSID to
// show/manage a share's capabilities on the Visibility tab; insert = grant, delete = revoke. Talks
// to the t1 backend (t1/v1/membership_capabilities); grant/revoke are guarded server-side on the
// TARGET group's administrator.
const URL = "t1/v1/membership_capabilities";

class MembershipCapabilityEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.MembershipCapability-001";

        let QBE = {
            "PlatformMessage": {
                "-idoc": idocResponse,
                "-id": uuidv4(),
                "MembershipCapability": {
                    '_attributes': {'limit': pageSize, 'sort': this.getFormattedSortSpecification(), 'offset': (page - 1) * pageSize},
                    "QueryGroups": {"QueryGroup": [{"Name": "primary", "Operator": "AND", "Type": "QueryGroup", "Membership": {"Member": []}}]}
                }
            }
        }
        let queryPayload = this.prepareQueryPayload();

        if (queryPayload.size > 0) {
            for (const [key, value] of queryPayload) {
                if (key.includes("_query")) continue;
                let operator = "EQUAL";
                if (queryPayload.get(key + "_query") !== undefined) operator = queryPayload.get(key + "_query");
                QBE.PlatformMessage.MembershipCapability.QueryGroups.QueryGroup[0].Membership.Member.push({
                    "Type": "Attribute", "Name": key, "Value": value, "Operator": operator
                })
            }
        }

        AxiosFoundationAPI({
            method: "GET",
            url: URL,
            json: true,
            params: {"QBE": btoa(JSON.stringify(QBE))},
            headers: {"idoc-response": idocResponse},
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1MembershipCapabilityIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};
        let membershipCapability = {};

        membershipCapability["USID"] = this.getAttributeValue("USID");
        membershipCapability["MembershipUSID"] = this.getAttributeValue("MembershipUSID");
        membershipCapability["CapabilityUSID"] = this.getAttributeValue("CapabilityUSID");

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.MembershipCapability-001";
        payload.PlatformMessage.MembershipCapability = membershipCapability;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();
        let options = {
            method: "POST", url: URL, json: true, data: payload,
            headers: {"idoc-request": "v1.MembershipCapability-001", "idoc-response": "v1.MembershipCapability-001", ...visibilityHeaders()},
        };
        this.notifyInsertStartListeners();
        AxiosFoundationAPI(options)
            .then(response => { this.insertEnterpriseComponentSuccess(V1MembershipCapabilityIDOCToArray(response.data)); })
            .catch(error => { this.insertEnterpriseComponentFailed(error); });
    };

    enterpriseComponentDeleteIDOC = () => {
        let payload = {};
        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.MembershipCapability-001";
        payload.PlatformMessage.MembershipCapability = {"USID": this.getAttributeValue("USID")};
        return payload;
    };

    performDelete() {
        let payload = this.enterpriseComponentDeleteIDOC();
        let options = {
            method: "DELETE", url: URL, json: true, data: payload,
            headers: {"idoc-request": "v1.MembershipCapability-001", ...visibilityHeaders()},
        };
        this.notifyDeleteStartListeners();
        AxiosFoundationAPI(options)
            .then(() => { this.deleteEnterpriseComponentSuccess(); })
            .catch(error => { this.deleteEnterpriseComponentFailed(error); });
    };
}

export default MembershipCapabilityEnterpriseComponent;
